/**
 * H5与小程序通信
 */

// H5设置小程序分享信息，文档：http://wiki.gacnio-inc.com/display/front/1.2-webview
const SET_SHARE_INFO = "setShareInfo";

/**
 * H5与APP通信
 * 文档链接：http://wiki.gacnio-inc.com/display/front/JsBridge
 */

// APP获取h5的分享信息，用于调起弹窗
const GET_SHARE_INFO = "getShareInfo";

// 是否展示APP左上角分享按钮
const SHARE_BT = "shareBt";

// 用于分享，拉起原生的分享弹窗，携带有指定对象显示该类型分享
const SOCIAL_SHARE = "socialShare";

// 页面进入前台 || 进入后台事件
const UNIVERSAL_REFRESH = "universalRefresh";

//组团成功弹窗
const GROUP_JOIN_SUCCESS = "groupJoinSuccess";

//分享弹窗
const GROUP_SHARE = "groupShare";

export default {
  SET_SHARE_INFO,
  GET_SHARE_INFO,
  SHARE_BT,
  SOCIAL_SHARE,
  UNIVERSAL_REFRESH,
  GROUP_JOIN_SUCCESS,
  GROUP_SHARE,
};
